// 朵迷藏

export default [
    {
        path: '/duomicang',
        component: () => import(/* webpackChunkName: "duomicang" */ '@/pages/duomicang/index.vue'),
        meta: {
            title: '会员', // 朵迷藏
        },
    },
];
